import Form from "../form";
import FormBuilderSortable from "../../../form_builder/models/formBuilderSortable";
import Guid from "~/helpers/guid";
import {NotificationDeliveryMethod} from "../../enums/reminderDeliveryMethod";
import IRepo from "../../../../common/interfaces/repo";
import Repo from "../../../../common/state/modules/repo";

export default class FormDetailReminder extends FormBuilderSortable {
  num_days_prior: string;
  delivery_methods: [NotificationDeliveryMethod];

  static repo: IRepo<FormDetailReminder> = new Repo<FormDetailReminder>('formDetailReminders', FormDetailReminder);

  constructor(form: Form, sort_order: number = 1) {
    super();
    this.rootModel = form;
    this.parent = form;
    this.defineProperty('sort_order', form.nextSortOrderFor(this.rootName));
    this.defineProperty('client_id', Guid.create());
    this.defineProperty('num_days_prior', 0);
    this.defineProperty('delivery_methods', []);
  }

  addDeliveryMethod(deliveryMethod): void {
    if (!this.delivery_methods.includes(deliveryMethod)) {
      this.delivery_methods.push(deliveryMethod);
    }
  }

  removeDeliveryMethod(deliveryMethod): void {
    if (this.delivery_methods.includes(deliveryMethod)) {
      const ind = this.delivery_methods.indexOf(deliveryMethod);
      this.delivery_methods.splice(ind, 1);
    }
  }

  get rootName() {
    return "reminders";
  }

  get displayName() {
    return "Reminder";
  }
}
